import React, { FC } from "react";
import { Toolbar } from "@mui/material";

import { StyledWrapper, StyledLayout } from "./GuestHeader.styled";

import { LanguageSwitcher } from "@components/common";

const GuestHeader: FC = () => (
  <StyledWrapper position="static">
    <Toolbar>
      <StyledLayout
        alignItems="center"
        direction="row"
        flexGrow={1}
        justifyContent="end"
        columnGap={2}
      >
        <LanguageSwitcher />
      </StyledLayout>
    </Toolbar>
  </StyledWrapper>
);

export default GuestHeader;
